import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../../components/FormikControl/FormikControl';
import { Add, Check, CheckBox, CheckBoxOutlineBlank, CheckBoxOutlineBlankOutlined, CheckCircle, Edit, FindReplace, Pending, PendingActions } from '@mui/icons-material';
import { useAlert } from '../../../../context/AlertContext';
import taskServices from '../taskServices';
import moment from 'moment';
import TaskDuration from './TaskDuration';


function TaskForm({data,masters,getMasterLabel,onSuccess,clanderDisplay=false}) {
    const {AppAlert} = useAlert();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const [deadline,setDeadLine] = useState(true);

    const initialValues = {
        clientId:"",
        projectId:"",
        priority:"",
        title:"",
        details:"",
        taskStatus:1,
        startDate:moment().format("YYYY-MM-DD"),
        endDate:moment().format("YYYY-MM-DD"),
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            clientId:data.clientId,
            projectId:data.projectId,
            priority:data.priority,
            title:data.title,
            details:data.details,
            taskStatus:data.taskStatus,
            startDate:moment(data.startDate).format("YYYY-MM-DD"),
            endDate:moment(data.endDate).format("YYYY-MM-DD"),
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        clientId:Yup.string().required("Required"),
        projectId:Yup.string().required("Required"),
        priority:Yup.string().required("Required"),
        title:Yup.string().required("Required"),
        //details:Yup.string().required("Required"),
        taskStatus:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {

        let _values = {...values};

        if(!deadline){
            delete _values.startDate;
            delete _values.endDate;
        }
        
        setSavingStatus(true);
        taskServices.save(_values).then(res=>{
            console.log(res.msg);
            AppAlert(res.msg);
            setDialogStatus(false);
            onSuccess()
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
        
    }

    const remove = () =>{
        if(data?.id){
            taskServices.remove(data.id).then(res=>{
                AppAlert("Archived");
                setDialogStatus(false);
                onSuccess()
            })
        }
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-sm mt-2 btn-outline-warning" onClick={addNew} ><Add/> Add New</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="View / Update">
                    <span type="button" className={
                            data.endDate === null ? 
                               clanderDisplay ? " text-warning px-0 py-0 ps-1 w-100 ":  "border-bottom border-primary text-warning px-0 py-0 ps-1 w-100 "
                            :
                               clanderDisplay ?  "text-white px-0 py-0 ps-1 w-100 " :"border-bottom border-primary text-white px-0 py-0 ps-1 w-100 "
                        } style={clanderDisplay ? {fontSize:12}: {fontSize:12}} onClick={updateData} >
                        {data.title}

                        
                        {!clanderDisplay  &&
                            <>
                            {data.taskStatus == 1 && <span className="text-danger px-1 ms-1"> <Pending sx={{fontSize:12}} /></span>}
                            {data.taskStatus == 2 && <span className="text-warning px-1 ms-1"><FindReplace sx={{fontSize:12}} /></span>}
                            {data.taskStatus == 3 && <span className="text-warning px-1 ms-1"><PendingActions sx={{fontSize:12}} /></span>}
                            {data.taskStatus == 4 && <span className="text-warning px-1 ms-1"><PendingActions sx={{fontSize:12}} /></span>}
                            {data.taskStatus == 5 && <span className="text-success px-1 ms-1"><CheckCircle sx={{fontSize:12}} /></span>}
                            </>
                        }
                        
                        {!clanderDisplay &&
                            <>
                            <span className={"badge bg-primary px-1 ms-1"}>{ getMasterLabel("priority", data.priority)}</span>
                            <TaskDuration dateTime={data.endDate} />
                            </>
                        }
                        
                        {clanderDisplay &&
                            <><br/>
                            <sapn className="bg-dark me-1 px-1 rounded">{getMasterLabel('client',data.clientId)}</sapn>
                            <sapn className="bg-primary me-1 px-1 rounded">{getMasterLabel('project',data.projectId)}</sapn>
                            <sapn className="bg-info me-1 px-1 rounded">{getMasterLabel('task-status',data.taskStatus)}</sapn>
                            </>
                        }
                    </span>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogContent>
                                            <div className="row">
                                                <div className="col-md-8 border border-primary">
                                                    <div className="row p-2">
                                                        <FormikControl control="input" formik={formik} type="text" 
                                                            label="Title" name="title" 
                                                            className="col-md-12 col-xs-12 my-3" 
                                                        />

                                                        <FormikControl control="input" formik={formik} type="text" multiline={true}
                                                            label="Details" name="details" 
                                                            className="col-md-12 col-xs-12 my-3" 
                                                        />
                                                    </div>
                                                
                                                    <div className="row p-2">
                                                        <div className='col-md-6'>
                                                            <button type="button" className='btn btn-outline-primary' onClick={()=>setDeadLine(!deadline)} >
                                                                {deadline ?  <CheckBox/> : <CheckBoxOutlineBlankOutlined />  }
                                                                <span className='ms-2'>Deadline</span>
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {deadline &&
                                                    <div className="row p-2">
                                                        <FormikControl control="input" formik={formik} type="date"
                                                            label="Start Date" name="startDate" 
                                                            className="col-md-6" 
                                                        />

                                                        <FormikControl control="input" formik={formik} type="date"
                                                            label="End Date" name="endDate" 
                                                            className="col-md-6" 
                                                        />
                                                    </div>
                                                    }
                                                </div>
                                                
                                                <div className="col-md-4">
                                                    <div className="row">
                                                        {masters && 
                                                            <FormikControl control="autoselect" formik={formik} 
                                                                label="Client" name="clientId"  
                                                                options={masters['client']} multiple={false} 
                                                                className="col-md-12 p-2"
                                                            />
                                                        }

                                                        {masters && 
                                                            <FormikControl control="autoselect" formik={formik} 
                                                                label="Project" name="projectId"  
                                                                options={masters['project']} multiple={false} 
                                                                className="col-md-12 p-2"
                                                            />
                                                        }

                                                        {masters && 
                                                            <FormikControl control="autoselect" formik={formik} 
                                                                label="Priority" name="priority"  
                                                                options={masters['priority']} multiple={false} 
                                                                className="col-md-12 p-2"
                                                            />
                                                        }

                                                        {masters && 
                                                            <FormikControl control="autoselect" formik={formik} 
                                                                label="Status" name="taskStatus"  
                                                                options={masters['task-status']} multiple={false} 
                                                                className="col-md-12 p-2"
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                                
                                                
                                                

                                                
                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        {data?.id !== undefined && <button className="btn btn-outline-primary float-end me-5" type="button" onClick={remove}>Archive</button> }
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values)  */}
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}
    

export default TaskForm